import './_bundle-builder.scss';
import {
    DISCOUNT_PERCENTAGES,
    DISCOUNT_THRESHOLDS,
    formatPrice,
    getTotalPrice,
    SELECTED_PRODUCTS_KEY, UPDATE_SELECTED_PRODUCTS
} from 'sections/bundle-builder/bundle-builder-helpers';

const CATEGORY_SELECTOR_CLASS = '.category-selector';
const DATA_CATEGORY = 'data-category';
const SELECTED_CLASS = 'selected';
const HIDDEN_CLASS = 'hidden';
const BTN_SECONDARY_CLASS = 'button--secondary';
const BTN_PRIMARY_CLASS = 'button--primary';
const DATA_PRODUCT_ID = 'data-product-id';
const DATA_VARIANT_ID = 'data-variant-id';
const ADD_TEXT = 'Add';
const ADD_LOWER = ADD_TEXT.toLowerCase();
const REMOVE_TEXT = 'Remove';
const REMOVE_LOWER = REMOVE_TEXT.toLowerCase();
const ADD_TO_BUNDLE_BTN = '.btn--add-to-bundle';
const NEXT_BTN = '.btn--bundle-builder-next';

const SELECTED_PRODUCTS = '.selected-products';
const SELECTED_PRODUCT_PRICE = '.selected-product-price';
const REMOVE_PRODUCT = '.remove-product';
const CONTENT_HEADER = '.bundle-builder-content-header';
const DATA_FREE_SHIPPING_THRESHOLD = 'data-free-shipping-threshold';

const FREE_SHIPPING_THRESHOLD = 3000;

class BundleBuilder extends HTMLElement {
    #selectedProducts = {};
    maxBundleSize = 5;

    get selectedProducts() {
        return this.#selectedProducts;
    }

    set selectedProducts(value) {
        this.#selectedProducts = value;
        this.updateSelectedProducts();
    }

    constructor() {
        super();
    }

    connectedCallback() {
        const sessionSelectedProducts = sessionStorage.getItem(SELECTED_PRODUCTS_KEY);
        if (sessionSelectedProducts) {
            const availableProductIds = [];
            this.querySelectorAll(ADD_TO_BUNDLE_BTN).forEach(btn => {
                availableProductIds.push(btn.getAttribute(DATA_PRODUCT_ID));
            });
            const selectedProducts = JSON.parse(sessionSelectedProducts);
            const selectedProductIds = Object.keys(selectedProducts);
            for(let i = 0; i < selectedProductIds.length; i++) {
                if(!availableProductIds.includes(selectedProductIds[i])) {
                    delete selectedProducts[selectedProductIds[i]];
                }
            }

            sessionStorage.setItem(SELECTED_PRODUCTS_KEY, JSON.stringify(selectedProducts));
            this.selectedProducts = selectedProducts;
        }

        this.maxBundleSize = this.getAttribute('data-max-bundle-size');

        this.querySelectorAll(CATEGORY_SELECTOR_CLASS).forEach((categorySelector, index) => {
            if(index === 0) {
                categorySelector.classList.add(SELECTED_CLASS);
            }
            categorySelector.addEventListener('click', () => {
                this.querySelectorAll(CATEGORY_SELECTOR_CLASS).forEach((el) => {
                    el.classList.remove(SELECTED_CLASS);
                });
                categorySelector.classList.add(SELECTED_CLASS);
                const category = categorySelector.getAttribute(DATA_CATEGORY);

                this.querySelectorAll('.bundle-product').forEach((product) => {
                    if(category === window.translations.all.toLowerCase()) {
                        product.classList.remove(HIDDEN_CLASS);
                    } else if (product.getAttribute(DATA_CATEGORY).split(' ').includes(category)) {
                        product.classList.remove(HIDDEN_CLASS);
                    } else {
                        product.classList.add(HIDDEN_CLASS);
                    }
                });
            });
        });

        this.querySelectorAll(ADD_TO_BUNDLE_BTN).forEach((btn) => {
            const selectedProductIds = Object.keys(this.selectedProducts);
            if (selectedProductIds.includes(btn.getAttribute(DATA_PRODUCT_ID))) {
                btn.classList.add(BTN_SECONDARY_CLASS);
                btn.classList.remove(BTN_PRIMARY_CLASS);
                btn.textContent = REMOVE_TEXT;
                btn.disabled = false;
            } else if (selectedProductIds.length >= this.maxBundleSize) {
                btn.disabled = true;
            }

            btn.addEventListener('click', () => {
                const textContent = btn.textContent.toLowerCase().trim();
                if (textContent === ADD_LOWER) {
                    this.addProductToBundle(btn);
                } else if (textContent === REMOVE_LOWER) {
                    const productId = btn.getAttribute(DATA_PRODUCT_ID);
                    removeProductFromSessionStorage(productId);
                }
            });
        });

        this.querySelector(NEXT_BTN).addEventListener('click', () => {
            location.href = window.localeUrl + '/pages/bundle-builder-review';
        });

        window.addEventListener(UPDATE_SELECTED_PRODUCTS, (e) => {
            const selectedProducts = e.detail;
            if(selectedProducts) {
                const parsedSelectedProducts = JSON.parse(selectedProducts);
                this.selectedProducts = parsedSelectedProducts;
                const selectedProductIds = Object.keys(parsedSelectedProducts);
                this.querySelectorAll(ADD_TO_BUNDLE_BTN).forEach((btn) => {
                    if (selectedProductIds.includes(btn.getAttribute(DATA_PRODUCT_ID))) {
                        btn.classList.add(BTN_SECONDARY_CLASS);
                        btn.classList.remove(BTN_PRIMARY_CLASS);
                        btn.textContent = REMOVE_TEXT;
                        btn.disabled = false;
                    } else {
                        btn.classList.remove(BTN_SECONDARY_CLASS);
                        btn.classList.add(BTN_PRIMARY_CLASS);
                        btn.textContent = ADD_TEXT;
                        btn.disabled = selectedProductIds.length >= this.maxBundleSize;
                    }
                });
            }
        });
    }

    addProductToBundle(btn) {
        if (Object.keys(this.selectedProducts).length >= this.maxBundleSize) {
            return;
        }

        const variantId = btn.parentElement.querySelector('input[name="id"]')?.value;
        const productId = btn.getAttribute(DATA_PRODUCT_ID);
        const name = btn.getAttribute('data-product-name');
        const selectedSwatchOption = btn.parentElement.querySelector(`.card__swatch--color-option.selected[${DATA_VARIANT_ID}="${variantId}"]`);
        const image =
            selectedSwatchOption?.getAttribute('data-image-src')
            ?? btn.getAttribute('data-product-image');
        const price = selectedSwatchOption?.getAttribute('data-variant-price') ?? btn.getAttribute('data-variant-price');

        if (!variantId || !productId || !image || !price || !name) return;

        addProductToSessionStorage(productId, variantId, name, image, price);
    }

    updateSelectedProducts() {
        const selectedProductIds = Object.keys(this.selectedProducts);
        this.querySelectorAll(SELECTED_PRODUCTS).forEach(selectedProductsSection => {
            selectedProductsSection.querySelectorAll('.selected-product').forEach((selectedProduct, index) => {
                const selectedProductInner = selectedProduct.querySelector('.selected-product-inner');
                if (selectedProductInner && selectedProductIds[index]) {
                    const selectedProductData = this.selectedProducts[selectedProductIds[index]];
                    selectedProductInner.innerHTML = `<img src="${selectedProductData.image}" alt="${selectedProductData.name}">`;
                    selectedProduct.querySelector(SELECTED_PRODUCT_PRICE).textContent = formatPrice(selectedProductData.price);
                    selectedProduct.querySelector(REMOVE_PRODUCT).classList.remove(HIDDEN_CLASS);
                    selectedProduct.dataset.productId = selectedProductIds[index];
                } else if (selectedProductInner) {
                    selectedProductInner.innerHTML = `
                    <svg
                        class="icon icon__plus"
                        aria-hidden="true"
                        focusable="false">
                        <use xlink:href="#icon-plus"></use>
                    </svg>`;
                    selectedProduct.querySelector(SELECTED_PRODUCT_PRICE).textContent = '\u200b';
                    selectedProduct.querySelector(REMOVE_PRODUCT).classList.add(HIDDEN_CLASS);
                    selectedProduct.removeAttribute(DATA_VARIANT_ID);
                }
            });
        });

        if(selectedProductIds <= 0) {
            this.querySelector(`${CONTENT_HEADER} > ${SELECTED_PRODUCTS}`).classList.add(HIDDEN_CLASS);
        } else {
            this.querySelector(`${CONTENT_HEADER} > ${SELECTED_PRODUCTS}`).classList.remove(HIDDEN_CLASS);
        }
        this.querySelector(NEXT_BTN).disabled = selectedProductIds <= 0;
    }
}

class BundleBuilderRemoveButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            this.removeProductFromBundle();
        });
    }

    removeProductFromBundle() {
        let productId = null;
        const isSummaryRemoveButton = !this.classList.contains('remove-button--selected-product');

        if(isSummaryRemoveButton) {
            productId = this.getAttribute(DATA_PRODUCT_ID);
        } else {
            productId = this.parentElement.getAttribute(DATA_PRODUCT_ID);
        }

        removeProductFromSessionStorage(productId);
    }
}

const START_PERCENTAGE = 25;
class DiscountProgressBar extends HTMLElement {
    freeShippingThreshold = FREE_SHIPPING_THRESHOLD;
    thresholds = {};

    constructor() {
        super();
    }

    connectedCallback() {
        this.freeShippingThreshold = parseInt(this.getAttribute(DATA_FREE_SHIPPING_THRESHOLD));
        this.thresholds[this.freeShippingThreshold] = {
            position: START_PERCENTAGE,
            discount: 0,
            label: window.translations.freeShipping
        };
        for(let i = 0; i < DISCOUNT_THRESHOLDS.length; i++) {
            this.thresholds[DISCOUNT_THRESHOLDS[i]] = {
                position: START_PERCENTAGE + (START_PERCENTAGE * (i + 1)),
                discount: DISCOUNT_PERCENTAGES[i],
                label: `${DISCOUNT_PERCENTAGES[i]}% ${window.translations.off}`
            };
        }
        Object.keys(this.thresholds).forEach((threshold) => {
            const marker = document.createElement('div');
            marker.classList.add('discount-progress-marker');
            marker.dataset.threshold = `${threshold}`;
            const position = this.thresholds[threshold].position;
            marker.style.left = `calc(${position}% - 16px)`;
            this.appendChild(marker);

            const label = document.createElement('div');
            label.classList.add('discount-progress-label');
            label.textContent = `${this.thresholds[threshold].label}`;
            label.style.left = `calc(${position}% - 8px)`;
            this.appendChild(label);
        });

        window.addEventListener(UPDATE_SELECTED_PRODUCTS, this.updateProgress.bind(this));
        this.updateProgress();
    }

    updateProgress() {
        const bundleBuilderTotal = getTotalPrice();
        let progress = 0;

        for(let i = 0; i < Object.keys(this.thresholds).length; i++) {
            const threshold = Object.keys(this.thresholds)[i];
            if (bundleBuilderTotal < threshold) {
                progress = (bundleBuilderTotal / threshold) * (START_PERCENTAGE * (i + 1));
                break;
            }
        }

        if (bundleBuilderTotal >= DISCOUNT_THRESHOLDS[2]) {
            progress = 100;
        }

        const progressBarFiller = this.querySelector('.discount-progress-filler');
        progressBarFiller.style.width =`${progress > 100 ? 100 : progress}%`;

        this.querySelectorAll('.discount-progress-marker').forEach((marker) => {
            const threshold = parseInt(marker.dataset.threshold);
            if (bundleBuilderTotal >= threshold) {
                marker.classList.add('discount-progress-marker--completed');
            } else {
                marker.classList.remove('discount-progress-marker--completed');
            }
        });

        const builderMessage = this.parentElement.querySelector('.discount-progress-message--builder');
        const summaryMessage = this.parentElement.querySelector('.discount-progress-message--summary');
        if(builderMessage) {
            builderMessage.innerHTML = this.getDiscountMessage(bundleBuilderTotal);
        } else if (summaryMessage) {
            summaryMessage.innerHTML = this.getDiscountSummaryMessage(bundleBuilderTotal);
        }

    }

    getDiscountMessage(currentTotal) {
        const discountMessages = [
            { limit: this.freeShippingThreshold, message: `✨ Just ${formatPrice((this.freeShippingThreshold - currentTotal).toString())} away from <strong>Free Shipping</strong>--almost there!` },
            { limit: DISCOUNT_THRESHOLDS[0], message: `✨ Free Shipping unlocked--add ${formatPrice((DISCOUNT_THRESHOLDS[0] - currentTotal).toString())} more for <strong>${this.thresholds[DISCOUNT_THRESHOLDS[0]].label}</strong>!` },
            { limit: DISCOUNT_THRESHOLDS[1], message: `✨ You're ${formatPrice((DISCOUNT_THRESHOLDS[1] - currentTotal).toString())} away from <strong>${this.thresholds[DISCOUNT_THRESHOLDS[1]].label}</strong> & Free Shipping!` },
            { limit: DISCOUNT_THRESHOLDS[2], message: `✨ Almost there! Add ${formatPrice((DISCOUNT_THRESHOLDS[2] - currentTotal).toString())} for <strong>${this.thresholds[DISCOUNT_THRESHOLDS[2]].label}</strong> & Free Shipping!` },
        ];

        for (let i = 0; i < discountMessages.length; i++) {
            if (currentTotal < discountMessages[i].limit) {
                return discountMessages[i].message;
            }
        }
        return `✨ Your perfect bundle now includes <strong>${this.thresholds[DISCOUNT_THRESHOLDS[2]].label}</strong> and <strong>Free Shipping</strong>!`;
    }

    getDiscountSummaryMessage(currentTotal) {
        let message = '';
        Object.keys(this.thresholds).forEach((threshold) => {
            if (threshold <= currentTotal) {
                message = this.thresholds[threshold].label;
            }
        });
        return message ? `✨ You qualify for <strong>${message}</strong>!` : window.translations.noSavings;
    }
}

function addProductToSessionStorage(productId, variantId, name, image, price) {
    const selectedProducts = sessionStorage.getItem(SELECTED_PRODUCTS_KEY);
    let newSelectedProductsString = '';
    if (!selectedProducts) {
        newSelectedProductsString = JSON.stringify({ [productId]: { variantId, name, image, price } });
        sessionStorage.setItem(SELECTED_PRODUCTS_KEY, newSelectedProductsString);
    } else {
        const parsedSelectedProducts = JSON.parse(selectedProducts);
        newSelectedProductsString = JSON.stringify({ ...parsedSelectedProducts, [productId]: { variantId, name, image, price } });
        sessionStorage.setItem(SELECTED_PRODUCTS_KEY, newSelectedProductsString);
    }

    const updateSelectedProductsEvent = new CustomEvent(UPDATE_SELECTED_PRODUCTS, { detail: newSelectedProductsString });
    window.dispatchEvent(updateSelectedProductsEvent);
}

function removeProductFromSessionStorage(productId) {
    const selectedProducts = sessionStorage.getItem(SELECTED_PRODUCTS_KEY);
    let newSelectedProductsString = '';

    if (!selectedProducts) return;
    const parsedSelectedProducts = JSON.parse(selectedProducts);

    // eslint-disable-next-line no-unused-vars
    const { [productId]: _, ...newSelectedProducts } = parsedSelectedProducts;
    newSelectedProductsString = JSON.stringify(newSelectedProducts);
    sessionStorage.setItem(SELECTED_PRODUCTS_KEY, newSelectedProductsString);

    const updateSelectedProductsEvent = new CustomEvent(UPDATE_SELECTED_PRODUCTS, { detail: newSelectedProductsString });
    window.dispatchEvent(updateSelectedProductsEvent);
}

customElements.define('bundle-builder', BundleBuilder);
customElements.define('bundle-builder-remove-button', BundleBuilderRemoveButton);
customElements.define('discount-progress-bar', DiscountProgressBar);
